import React from "react";
import PropTypes from "prop-types";
import { useDroppable } from "@dnd-kit/core";

const QuickDropZone = ({ listing, onQuickDrop }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `quick-drop-${listing.releaseId}`,
    data: {
      type: 'quick-drop',
      targetReleaseId: listing.releaseId
    }
  });

  const discogsCoverUrl = listing.formData?.imageUrl;
  const title = listing.formData?.releaseTitle || "Unknown Album";
  const artist = Array.isArray(listing.formData?.artist)
    ? listing.formData.artist.join(", ")
    : listing.formData?.artist || "Unknown Artist";

  return (
    <div
      ref={setNodeRef}
      className={`
        relative flex-shrink-0 w-20 h-20 border-2 border-dashed rounded-lg
        transition-all duration-200 cursor-pointer
        ${isOver
          ? 'border-green-400 bg-green-400/20 scale-105'
          : 'border-zinc-600 bg-zinc-800/50 hover:border-zinc-500'
        }
      `}
      title={`Drop photos here for: ${artist} - ${title}`}
    >
      {discogsCoverUrl ? (
        <img
          src={discogsCoverUrl}
          alt={`${artist} - ${title}`}
          className="w-full h-full object-cover rounded-md opacity-70"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-xs text-zinc-500 p-1 text-center">
          No Cover
        </div>
      )}

      {/* Overlay with record info */}
      <div className="absolute inset-0 bg-black/60 rounded-md flex flex-col justify-end p-1 opacity-0 hover:opacity-100 transition-opacity">
        <div className="text-xs text-white text-center leading-tight">
          <div className="font-semibold truncate">{artist}</div>
          <div className="truncate">{title}</div>
        </div>
      </div>

      {/* Drop indicator */}
      {isOver && (
        <div className="absolute inset-0 rounded-md bg-green-400/40 flex items-center justify-center">
          <div className="text-white font-bold text-xs">DROP HERE</div>
        </div>
      )}
    </div>
  );
};

const QuickDropZones = ({ listings, onQuickDrop }) => {
  if (!listings || listings.length === 0) return null;

  return (
    <div className="mt-4 mb-6">
      <h4 className="text-sm font-medium text-zinc-400 mb-3 text-center">
        Quick Drop Zones - Drag photos to these covers to instantly assign them
      </h4>
      <div className="flex justify-center gap-3 flex-wrap">
        {listings.map((listing) => (
          <QuickDropZone
            key={listing.releaseId}
            listing={listing}
            onQuickDrop={onQuickDrop}
          />
        ))}
      </div>
    </div>
  );
};

QuickDropZone.propTypes = {
  listing: PropTypes.object.isRequired,
  onQuickDrop: PropTypes.func.isRequired,
};

QuickDropZones.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.object).isRequired,
  onQuickDrop: PropTypes.func.isRequired,
};

export default QuickDropZones;